import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import {Drawer, useTheme} from "@mui/material";
import PromoBar from "./PromoBar";
import DinoIconButton from "./DinoButton";
import {createTheme} from "@mui/material/styles";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {useContext} from "react";
import ConfigContext from "../context/ConfigContext";
import {useHistory} from "react-router-dom";
import {HashLink} from "react-router-hash-link";





function DinoAppBar({name, logo}) {

    const theme = useTheme();
    const history = useHistory()
    const {config, baseUrl} = useContext(ConfigContext)
    const pages = [
        {name: 'Kezdőlap', link: '/#home'},
        {name: 'Szolgáltatások', link: '/#services'},
        {name: 'Kollégáink', link: '/#colleagues'},
        {name: 'Kapcsolat', link: '/#contact-us'},
    ]
    const webShopNeeded = config?.usage_type === 'website_webshop'

    if (webShopNeeded) {
        pages.push({name: 'Termékek', link: '/products'})
    }


    const buttonTheme = createTheme({
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: 'white', backgroundColor: theme.palette.primary.main, '&:hover': {
                            backgroundColor: theme.palette.secondary.main,
                        },
                        borderRadius: 30,
                        textTransform: 'capitalize',
                        width: 'fit-content',
                        fontFamily: 'Archivo',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '18px',
                        padding: '15px 16px 15px 12px',
                        height: 'fit-content',
                        margin: '14px',
                    }
                }
            }
        },
    })


    const style = {
        background: theme.palette.background.paper,
        color: theme.palette.text.secondary,
    }

    const serviceProviderTextStyle = {
        color: '#38474D',
        padding: 12,
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '20px',
    }

    const menuIconStyle = {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '30px',
        color: 'white',
    }

    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const toggleNavMenu = (event) => {
        setAnchorElNav(!Boolean(anchorElNav) ? event.currentTarget : null);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -117;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    return (
        <AppBar position="sticky" sx={style}>
            <PromoBar/>
            <Container maxWidth="xl">

                <Toolbar disableGutters>
                    <Box sx={{flexGrow: 0}}>
                        <Tooltip title={name + ' logo'}>
                            <IconButton sx={{p: 0}} onClick={() => history.push('/')}>
                                <Avatar sx={{background: theme.palette.primary[200]}} alt={name?.toUpperCase()} src={baseUrl + logo}/>
                            </IconButton>
                        </Tooltip>
                        <span style={serviceProviderTextStyle}>{name}</span>
                    </Box>
                    <Box sx={{display: {xs: 'flex', md: 'none'}, marginLeft: 'auto', zIndex: '11'}}>
                        <div style={menuIconStyle}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={toggleNavMenu}
                                color="inherit"
                            >
                                {!anchorElNav ? <MenuIcon/> : <CloseIcon/>}
                            </IconButton>
                        </div>
                        <Drawer
                            anchor={'top'}
                            open={Boolean(anchorElNav)}
                            onClose={toggleNavMenu}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            BackdropProps={{invisible: true}}
                            sx={{
                                '& .MuiDrawer-paper': {
                                    boxSizing: 'border-box',
                                    width: '100%',
                                    height: '80%',
                                    marginTop: '95px'
                                },
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                zIndex: '10'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                margin: 'auto',
                                gap: '48px'
                            }}>
                                {pages.map((page) => (
                                    <MenuItem key={page.name + 'mobile'} onClick={handleCloseNavMenu}>
                                        <HashLink to={page.link} scroll={el => scrollWithOffset(el)} style={{textDecoration: 'none', color: theme.palette.primary[600]}}>
                                            <Typography textAlign="center" variant="subtitle2">{page.name}</Typography>
                                        </HashLink>
                                    </MenuItem>
                                ))}
                                <DinoIconButton className="dino-hero-content__button" icon={<CalendarTodayIcon/>}
                                                theme={buttonTheme} text='Időpont foglalás'
                                                onClick={() => history.push('/book')}/>
                            </div>

                        </Drawer>

                    </Box>

                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}, justifyContent: 'flex-end'}}>
                        {pages.map((page) => (
                            <HashLink key={page.name} to={page.link} scroll={el => scrollWithOffset(el)} style={{textDecoration: 'none', display: 'flex'}}>
                                <Button sx={{my: 2, display: 'block'}} style={{alignSelf: "center", color: theme.palette.primary[600]}}>
                                    {page.name}
                                </Button>
                            </HashLink>
                        ))}
                        <DinoIconButton className="dino-hero-content__button"
                                        icon={<CalendarTodayIcon/>}
                                        theme={buttonTheme}
                                        text='Időpont foglalás' onClick={() => history.push('/book')}/>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default DinoAppBar;
